import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { first } from 'rxjs/operators';
import { CartService } from '../../../finance/shared/services/cart.service';
import { BaseComponent } from '../../../shared/base-components/base.component';

@Component({
    selector: 'different-agent-cart-modal',
    templateUrl: './different-agent-cart-modal.html'
})
export class DifferentAgentCartWindow extends BaseComponent {

    constructor(public dialogRef: MatDialogRef<DifferentAgentCartWindow>,
        private cartService: CartService) {
        super();
    }

    ngOnInit() {
    }

    public async clearCart() {
        await this.cartService.clearCart().pipe(first()).toPromise();
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialogRef.close();
    }
}
